import { Customer } from '../../../selectors/select-customer/types';
import PromoOfferBanner from './components/promo-offer-banner';
import UpsellOfferBanner from './components/upsell-offer-banner';
import useShouldShowOfferBanner from './use-should-show-offer-banner';
import type { Offer, OfferPresaleText, OfferRewards, Placeholder } from '../types';
import type { ProductTypeType } from '../../../types/product';

export type OfferBannerVariant = 'inHero' | 'sideBordered' | 'bordered';

type OfferBannerProps = {
  customer?: Customer;
  // Per-product eligibility filtering
  filterProductId?: string;
  // Per-category filtering
  filterProductType?: ProductTypeType;
  // Pre-resolved offers; bypasses useGetActivePromoOffer
  overrideOffers?: Offer[];
  placeholders?: Placeholder[];
  presaleEnd?: OfferPresaleText;
  presaleSentence?: OfferPresaleText;
  rewards?: OfferRewards;
  targetSegment?: string;
  variant?: OfferBannerVariant;
  withUpsell?: boolean;
};

const OfferBanner = ({ customer, withUpsell, variant, ...rest }: OfferBannerProps) => {
  const shouldShow = useShouldShowOfferBanner();
  if (!shouldShow) {
    return null;
  }
  if (withUpsell) {
    return <UpsellOfferBanner customer={customer} variant={variant} />;
  }
  return <PromoOfferBanner {...rest} variant={variant} />;
};

export default OfferBanner;
